<template>
  <div :class="sectionClass" v-if="show">
    <div class="notification-section__title">
      <slot name="section-icon"></slot>
      {{ title }}
    </div>
    <div v-if="clearSection" class="clear-notification-list" :title="sectionClearTitle" @click="clearNotificationsList">Borrar todo</div>
  </div>
</template>

<script lang="ts">
import { AsyncTaskStatus } from '@/types/catalogs/AsyncTask'
import Vue from 'vue'

export default Vue.extend({
  props: {
    status: {
      type: String,
      default: 'NEW'
    },
    title: {
      type: String,
      default: 'Tareas'
    },
    show: {
      type: Boolean,
      default: false
    },
    clearSection: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    sectionClass (): String {
      return `notification-section__list--${this.status}`
    },
    sectionClearTitle (): String {
      let title = 'Borrar todas las notificaciones: '
      if (this.status === AsyncTaskStatus.NEW) {
        title += 'nuevas'
      } else if (this.status === AsyncTaskStatus.PROCESSING) {
        title += 'en proceso'
      } else if (this.status === AsyncTaskStatus.DONE) {
        title += 'finalizadas'
      } else if (this.status === AsyncTaskStatus.ERROR) {
        title += 'con error'
      } else if (this.status === AsyncTaskStatus.WAITING) {
        title += 'en espera'
      } else if (this.status === AsyncTaskStatus.CANCELED) {
        title += 'canceladas'
      }
      return title
    }
  },
  methods: {
    clearNotificationsList (): void {
      this.$emit('clear-notifications', this.status)
    }
  }
})
</script>

<style lang="scss" scoped>
div[class*="notification-section__list"] {
  position: sticky;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1rem;
  font-size: 0.8rem;
  font-weight: bold;
  line-height: 2rem;
  background-color: #ccc;
  z-index: 1001;

  .notification-section__title > i {
    width: 12.81px;
    margin: 0 5px 0 0;
    text-align: center;
  }

  .clear-notification-list {
    font-size: 0.75rem;
    font-weight: normal;
    line-height: 1rem;
    padding: 0 6px;
    border-radius: 6px;
    transition-duration: 200ms;
    cursor: pointer;
  }
}
@media screen and (hover:hover) {
  .clear-notification-list:hover {
    background-color: var(--element-hover-bg-color);
    transition-duration: 200ms;
  }
}
</style>
